// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"4edef41a","599":"f67741ab","631":"d5dc2d26","653":"d80c1eb9","731":"46315f3d","975":"b3b512cb"}[chunkId] + ".chunk.js";
};